import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";

import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";

@Component({
  selector: "overflow-menu-button",
  templateUrl: "overflow-menu-button.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, NgClickOutsideDirective, TranslatePipe],
})
export class OverflowMenuButton {
  readonly enabled = input(true);

  protected menuActive = signal(false);

  protected toggleMenu() {
    this.menuActive.update((v) => !v);
  }

  protected closeMenu() {
    this.menuActive.set(false);
  }
}
